
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android-mobile-app-development-services",
      function () {
        return require("private-next-pages/android-mobile-app-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android-mobile-app-development-services"])
      });
    }
  